import {usePlayerStore} from '@common/player/hooks/use-player-store';
import {isMatchingMediaIdentity} from '@common/player/hooks/use-is-media-cued';

export function useIsTrackCued(
  trackId: number,
  groupId?: string | number
): boolean {
  return usePlayerStore(s => {
    const currentTrackId = s.cuedMedia?.meta?.id ?? s.cuedMedia?.id;
    return isMatchingMediaIdentity(
      currentTrackId != null
        ? {
            id: currentTrackId,
            groupId: s.cuedMedia?.groupId,
          }
        : undefined,
      trackId,
      groupId,
    );
  });
}
